import { advanceTask } from './advanceTask'
import { IJob, registerJob } from './jobs'
import { createTask_deconstructHull } from './taskDeconstructHull'
import { createTask_enterShip } from './taskEnterShip'
import { createTask_moveTo } from './taskMoveTo'
import { createTask_placeInEmptySpace } from './taskPlaceInEmptySpace'
import { jobLogger } from './jobLogger-sidecar'

export const register = () =>
  registerJob('deconstruct-hull', advanceJob_deconstructHull)

export function advanceJob_deconstructHull(job: IJob) {
  jobLogger.assertJobType(job, 'deconstruct-hull')

  let as = jobLogger.assertBlueprint(job)
  let m = jobLogger.assertReserved(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.isFailed = false
    job.tasks = []

    // Go to blueprint
    let task = createTask_moveTo(as.i, as.j, false, true)
    job.tasks.push(task)

    // Deconstruct
    task = createTask_deconstructHull(as.i, as.j)
    job.tasks.push(task)

    // Go inside
    task = createTask_enterShip(m.i, m.j)
    job.tasks.push(task)

    // Put down in open spot
    task = createTask_placeInEmptySpace(m.i, m.j)
    job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
